import { RouteConfig } from 'vue-router';

import List from './views/List.vue';
import Form from './views/Form.vue';
import InvoiceContact from './views/InvoiceContact.vue';
import BankAccountCollection from './views/BankAccountCollection.vue';

export default [
  // list
  {
    name: 'businessunit',
    path: '',
    component: List,
  },
  // edit
  {
    path: ':id(new|\\d+)',
    component: Form,
    meta: {
      hideMenu: true,
      hideTab: true,
    },
  },
  // invoice contact
  {
    path: ':id(\\d+)/invoicecontact',
    component: InvoiceContact,
    meta: {
      hideMenu: true,
      hideTab: true,
    },
  },
  // bank account collection
  {
    path: ':id(\\d+)/bankaccountcollection',
    component: BankAccountCollection,
    meta: {
      hideMenu: true,
      hideTab: true,
    },
  },

] as RouteConfig[];
